module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f9c6.a94024f8.svg";